import { useMemo } from 'react'
import { ColorRepresentation, LineCurve3 } from 'three'
import { useTheme } from '@mui/material'
import { ImmutableVector3 } from '@modugen/ui-toolkit'
import { nthLooped } from '@utils'

const width = 0.02

interface Props {
  points: ImmutableVector3[]
  selected: boolean
  color?: ColorRepresentation
}

const SelectionBorder = ({ points, selected, color }: Props) => {
  const { scenePalette } = useTheme()

  const geometries = useMemo(() => {
    const edges = points.map((p, i) => {
      const end = nthLooped(points, i + 1)
      return new LineCurve3(p.v, end.v)
    })

    return edges
  }, [points])

  if (!selected) return null

  return (
    <>
      {geometries.map((geometry, index) => (
        <mesh key={index}>
          <tubeGeometry args={[geometry, 100, width, 50, false]} />
          <meshStandardMaterial
            color={color || scenePalette.highlightDark}
            polygonOffset
            polygonOffsetUnits={-250}
          />
        </mesh>
      ))}
    </>
  )
}

export default SelectionBorder
